import { render, staticRenderFns } from "./FamiliaForm.vue?vue&type=template&id=65e21944&"
import script from "./FamiliaForm.vue?vue&type=script&lang=js&"
export * from "./FamiliaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports